import { useServerData, LIST_MIN_LOADING_MS } from '@/hooks/useServerData';
import { AgencyDashboardService } from '@/services/agencyDashboard.service';
import {
    AgencyClientRow,
    AgencyDashboardPeriod,
} from '@/integrations/supabase/rpc-types';

interface UseAgencyClientsParams {
    /** Controllato dal padre: e' lo stesso selettore delle altre tab della pagina. */
    period: AgencyDashboardPeriod;
    designerId: string | null;
    /** Gia' con il debounce applicato dal chiamante. */
    search: string;
}

/**
 * Lista clienti della tab Clienti, tutta in memoria: la paginazione e' del componente.
 *
 * La ricerca e' filtrata dal database e non in memoria: cerca anche fra le destinazioni,
 * che nella riga sono troncate e quindi non tutte visibili al filtro del browser.
 */
export function useAgencyClients(params: UseAgencyClientsParams, refreshKey: number) {
    return useServerData<AgencyClientRow[]>(
        JSON.stringify({ params, refreshKey }),
        [],
        () => AgencyDashboardService.getClients(params.period, params.designerId, params.search),
        true,
        LIST_MIN_LOADING_MS
    );
}

export default useAgencyClients;
